<template>
  <div class="input-group">
    <flat-pickr
      :config="config"
      v-model="value"
      class="form-control"
      @on-close="handleControl(timePickerValue)"
    />
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';
import { convertMiliSecsToTime, convertTimeToMiliSecs } from '@/utils/time';

export default {
  name: 'TimeInput',
  mixins: [
    BaseControlMixin,
  ],
  data() {
    return {
      timePickerValue: this.vars[0].value,
      config: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i:S',
        time_24hr: true,
      },
    };
  },
  computed: {
    value: {
      get() {
        return convertMiliSecsToTime(this.getSingleVar.value);
      },
      set(value) {
        this.timePickerValue = convertTimeToMiliSecs(value);
      },
    },
  },
  components: {
    flatPickr,
  },
};
</script>

<style scoped>

</style>
